import Image from "next/image";
import type { GuideImage } from "@/content/guide-schema";
import { isConfiguredSystemImageUrl } from "@/lib/system-images/policy";
import { cn } from "@/lib/utils";

export function GuideContentImage({
  className,
  image,
}: {
  className?: string;
  image: GuideImage;
}) {
  if (!isConfiguredSystemImageUrl(image.url)) return null;

  return (
    <div
      className={cn(
        "relative aspect-video w-full overflow-hidden rounded-2xl border bg-background",
        className,
      )}
      style={{ maxHeight: image.maxHeight, maxWidth: image.maxWidth }}
    >
      <Image
        src={image.url}
        alt=""
        fill
        sizes="(max-width: 1024px) calc(100vw - 3rem), 800px"
        className="object-contain"
      />
    </div>
  );
}
